export default "__VITE_ASSET__Gnj9dTqo__"